import styled, { css } from 'styled-components';
import {
    Text, Button, Spacer, Select,
} from '@zillow/constellation';

export const StyledUppercaseText = styled(Text)`
    && {
        line-height: 36px;
        text-transform: uppercase;
    }
`;

export const StyledSchedulerButton = styled(Button)`
    ${props => props.theme &&
    props.theme.ns &&
    css`
        && {
            border-radius: 30px;
            /* removes user agent style (chrome) that puts a yellow outline around button on focus */
            outline-width: 0; 
            ${props.type === 'outline' && css`
                background: ${props.theme.ns().colors.white};
                border: 1px solid ${props.theme.ns().colors.gray500};
                color: ${props.theme.ns().colors.gray500};

                ${!props.disabled && css`
                    &:hover,
                    &:focus {
                        background: ${props.theme.ns().colors.gray200};
                        border: 1px solid  ${props.theme.ns().colors.gray300};
                    }

                    &.active,
                    &:active {
                        background: ${props.theme.ns().colors.gray200};
                    }
                `}
            `}

            ${props.type === 'outlineFill' && css`
                background: #118900;
                border: 1px solid ${props.theme.ns().colors.gray400};
                color: ${props.theme.ns().colors.white};
                ${!props.disabled && css`
                    &:hover,
                    &:focus {
                        background: ${props.theme.ns().colors.green300};
                    }

                    &.active,
                    &:active {
                        background: ${props.theme.ns().colors.green400};
                    }
                `}
            `}
        }
    `
}`;

export const StyledInlineSpacer = styled(Spacer)`
    display: inline;
`;

export const StyledSchedulerDaySelect = styled(Select)`
    max-width: 375px;
`;
